import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CommentIcon from "@mui/icons-material/Comment";
import { DocumentItemStyles } from "./GenericOrderInfoStyles";
import EditIcon from "@mui/icons-material/Edit";
import { DeletePopup } from "@Components/Popup/DeletePopup";
import useDeleteItem from "../../Hooks/useDeleteItem";
import DeleteIcon from "@mui/icons-material/Delete";
import MeatballsMenu from "@Components/MeatballsMenu/MeatballsMenu";
import {
  inputTypes,
  cargoxNames,
  cargoxStatuses,
} from "../../Utils/HelpingObjects/HelpingObjects";
import { useState } from "react";
import { EditSectionPopup } from "../GenericForm/EditSectionPopup";
import useSendPutRequest from "@Hooks/useSendPutRequest";
import { CARGOX_URL } from "../../API/APIRoutes";
import { useEffect } from "react";
import { formatDateUTC } from "../../Utils/Validations/HelperFunctions/FormaterFunctions";
import { ca } from "date-fns/locale";
export default function CargoXList({
  orderId,
  cargoXs: initialCargoXs,
  selectedObject,
  setSelectedObject,
  editable,
}) {
  const [cargoXs, setCargoXs] = useState(initialCargoXs || []);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [selectedCargoX, setSelectedCargoX] = useState(null);
  const { isLoading: PutItemLoading, requestMethod: putItem } =
    useSendPutRequest();

  useEffect(() => {
    setCargoXs(initialCargoXs || []);
  }, [initialCargoXs]);

  const formFields = [
    {
      size: 12,
      type: inputTypes.SEARCHABLE_DROPDOWN,
      key: "cargoXName",
      label: "CargoX Name",
      options: cargoxNames,
      editable: false,
    },
    {
      size: 12,
      type: inputTypes.SEARCHABLE_DROPDOWN,
      key: "cargoXStatus",
      label: "CargoX Status",
      options: cargoxStatuses,
      editable: true,
    },
    {
      size: 12,
      type: inputTypes.DATE,
      key: "cargoXUploadDate",
      label: "Upload Date",
      editable: true,
    },
    {
      size: 12,
      type: inputTypes.TEXT,
      key: "comment",
      label: "Comment",
      editable: true,
    },
  ];

  const onEditCargoX = (cargoX) => {
    setSelectedCargoX(cargoX);
    setShowEditPopup(true);
  };
  const closeEditPopup = () => setShowEditPopup(false);

  const confirmEdit = async (newCargoXData) => {
    const processedData = {
      ...newCargoXData,
      cargoXUploadDate: formatDateUTC(newCargoXData.cargoXUploadDate),
      orderId: Number(orderId), // Convert orderId to number
    };
    const response = await putItem(
      CARGOX_URL,
      processedData,
      `CargoX Edited Successfully!`,
      `Failed To Edit CargoX`
    );
    // Update the local approvals array with the edited approval
    const updatedCargoXs = cargoXs.map((cargoX) => {
      if (
        cargoX.cargoXId === newCargoXData.cargoXId ||
        cargoX.cargoXName === newCargoXData.cargoXName
      ) {
        return processedData;
      }
      return cargoX;
    });

    setCargoXs(updatedCargoXs);
    window.location.reload();

    closeEditPopup();
  };
  //**************************** Delete CargoX ****************************/
  const { loading: deleteLoading, deleteItem } = useDeleteItem();
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedCargoXToDelete, setSelectedCargoXToDelete] = useState(null);

  const openDeletePopup = (cargoX) => {
    setSelectedCargoXToDelete(cargoX);
    setShowDeletePopup(true);
  };
  const closeDeletePopup = () => {
    setShowDeletePopup(false);
  };
  const confirmDelete = async (cargoXId) => {
    await deleteItem(
      cargoXId,
      closeDeletePopup,
      CARGOX_URL,
      `CargoX Deleted Successfully!`,
      `Failed To Delete CargoX`
    );
    // Update the local cargoXs array by filtering out the deleted cargoX
    const updatedCargoXs = cargoXs.filter(
      (cargoX) => cargoX.cargoXId !== cargoXId
    );
    setCargoXs(updatedCargoXs);
    window.location.reload();
    closeDeletePopup();
  };
  //**************************** MeatballsMenu Options ****************************/
  const meatballsMenuOptions = (cargoX) => [
    {
      label: "Edit CargoX",
      icon: <EditIcon />,
      color: "primary",
      action: () => onEditCargoX(cargoX),
      showOption: editable,
    },
    {
      label: "Delete CargoX",
      icon: <DeleteIcon />,
      color: "error",
      action: () => openDeletePopup(cargoX),
      showOption: editable,
    },
  ];
  return (
    <Box sx={{ maxHeight: "85vh", overflowY: "auto" }}>
      {cargoXs.map((cargoX, idx) => {
        const cargoXId = `${cargoX.cargoXName}-${idx}`;
        const isSelected = selectedObject?._cargoXId === cargoXId;

        return (
          <Box
            key={cargoXId}
            onClick={() =>
              setSelectedObject({ ...cargoX, _cargoXId: cargoXId })
            }
            sx={{
              ...DocumentItemStyles(isSelected),
              position: "relative", // Add position relative to container
            }}
          >
            {/* Meatballs menu for invoice actions */}
            {editable && (
              <Box
                sx={{ position: "absolute", right: 10, top: 10 }}
                onClick={(e) => e.stopPropagation()} // Stop propagation to prevent invoice selection
              >
                <MeatballsMenu options={meatballsMenuOptions(cargoX)} />
              </Box>
            )}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 7,
              }}
            >
              <Typography variant="subtitle1">
                Name: {cargoX.cargoXName.replace(/_/g, " ")}
              </Typography>
              <Typography variant="subtitle1">
                State: {cargoX.cargoXStatus.replace(/_/g, " ")}
              </Typography>
            </Box>

            <Typography variant="caption" color="text.secondary">
              Uploaded: {new Date(cargoX.cargoXUploadDate).toLocaleDateString()}
            </Typography>

            {cargoX.comment && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  mt: 1,
                  flexWrap: "nowrap",
                }}
              >
                <CommentIcon sx={{ color: "text.secondary" }} />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ whiteSpace: "nowrap", flexShrink: 0 }}
                >
                  Comment:
                </Typography>
                <Typography
                  variant="body2"
                  fontStyle="italic"
                  sx={{ overflowWrap: "anywhere", flex: 1 }}
                >
                  {cargoX.comment}
                </Typography>
              </Box>
            )}
          </Box>
        );
      })}
      {EditSectionPopup(
        "CargoX",
        showEditPopup,
        closeEditPopup,
        confirmEdit,
        PutItemLoading,
        formFields,
        selectedCargoX
      )}
      {DeletePopup(
        "CargoX",
        showDeletePopup,
        closeDeletePopup,
        () => confirmDelete(selectedCargoXToDelete?.cargoXId),
        null,
        deleteLoading
      )}
    </Box>
  );
}
